// 英文
import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
  request: {
    loading: 'Loading',
    timeout: 'Request timed out',
    fail: 'Failed to get data'
  },
  route: {
    dashboard: 'front page',
    bcms: 'host management',
    broadcast: 'host list',
    liveDuration: 'Live streaming statistics',
    liveDurationDetail: 'Single live broadcast data details',
    agentms: 'agency management',
    agent: 'agency list',
    anchor: 'agency subordinate host list',
    bms: 'cash statistics',
    pearl: 'total pearl statistics'
  },
  mod_password: 'change Password',
  logout: 'sign out',
  welcome: 'Welcome to the management system!',
  // *********按钮区***********
  search_btn: 'Inquire',
  export_excel_btn: 'Export to Excel',
  mod_btn: 'edit',
  add_btn: 'new',
  cancel_btn: 'Cancel',
  save_btn: 'save',
  confirm_btn: 'confirm',
  main_btn: 'operate',
  day_1: '1 day',
  day_3: '3 days',
  day_7: '7 days',
  lately_week: ' last week',
  lately_one_month: 'last month',
  lately_three_month: 'last three months',
  day_infinitely: 'Permanent ban',
  day: 'day',
  hour: 'hour',
  minute: 'minute',
  // *********常用输入限制***********
  maxlength_20: 'Up to 20 characters',
  maxlength_50: 'Up to 50 characters',
  // **********消息提示**********
  modify_success_message: 'Successfully modified',
  submit_success_message: 'Submitted successfully',
  user_type: {
    name_0: 'user',
    name_1: 'host',
    name_2: 'agent'
  },
  user_new: {
    name_0: 'no',
    name_1: 'yes'
  },
  ...enLocale,
  user_id: 'User ID',
  user_id_placeholder: 'Please enter user ID',
  user_name: 'Nickname',
  user_name_placeholder: 'Please enter user nickname',
  user_real_name: 'actual name',
  user_phone: 'Phone number',
  order_by_desc_placeholder: 'Please select a sorting method',
  idcard: 'identity number',
  close: 'close',
  checkAll: 'select all',
  user_language_lable_option_1: 'Chinese',
  user_language_lable_option_2: 'English',
  user_language_lable_option_3: 'Indonesia',
  user_language_lable_option_0: 'Global',
  user_language_lable_option_4: 'Malay',
  user_language_lable_option_5: 'Arabic',
  diamond_type_option_1: 'income',
  diamond_type_option_2: 'expenditure',
  pay_at: 'transaction hour',
  log_change_type: 'Flow type',
  diamond_type: 'Transaction Type',
  id_type_placeholder: 'please choose',
  form_rules_required: 'Required',
  rule_not_empty: 'Can not be empty',
  rule_mobile: 'please enter the correct phone number',
  rule_email: 'Please enter correct email',
  rule_start_date: 'Please select a start date',
  rule_end_date: 'Please select an end date',
  rule_date: 'Please select a date',
  rule_select: 'Please choose one',
  rule_number: 'Please enter a numeric value',
  rule_number_pot: 'Please fill in the number, up to 2 decimal places',
  rule_id_number_empty: 'ID number cannot be empty',
  rule_id_number_error: 'ID number is incorrect',
  rule_int_number: 'Please enter an integer',
  rule_confirm_password: 'Inconsistent password entered twice',
  rule_code: 'Mobile verification code',
  rule_zh_mobile: 'Currently only mobile phone numbers in mainland China are supported',
  rule_password: 'Length must between eight and sixteen characters',
  rule_upload_imgs: 'Please select an image'
}

export default en
